import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    continueCta: 'Continue',
    directorDescription: {
      future:
        'You will legally represent the company or have a mandate as Président or Gérant.',
      present:
        'You legally represent the company or have a mandate as Président or Gérant.',
    },
    directorLabel: {
      future: 'Will you be a director of the company?',
      present: 'Are you a director of the company?',
    },
    majorShareholderDescription: {
      future:
        'You will be a shareholder of at least 25% of the capital, directly or indirectly.',
      present:
        'You are a shareholder of at least 25% of the capital, directly or indirectly.',
    },
    majorShareholderLabel: {
      future: 'Will you hold 25% or more of the company’s shares?',
      present: 'Do you hold 25% or more of the company’s shares?',
    },
    no: 'No',
    title: 'Your role in the company',
    yes: 'Yes',
  },
  fr: {
    continueCta: 'Continuer',
    directorDescription: {
      future:
        'Vous représenterez légalement l’entreprise ou disposerez d’un mandat, président ou gérant.',
      present:
        'Vous représentez légalement l’entreprise ou disposez d’un mandat, président ou gérant.',
    },
    directorLabel: {
      future: 'Serez-vous un·e dirigeant·e de l’entreprise\u00A0?',
      present: 'Êtes-vous un·e dirigeant·e de l’entreprise\u00A0?',
    },
    majorShareholderDescription: {
      future:
        'Vous serez actionnaire d’au moins 25\u00A0% du capital, directement ou non.',
      present:
        'Vous êtes actionnaire d’au moins 25\u00A0% du capital, directement ou non.',
    },
    majorShareholderLabel: {
      future:
        'Disposerez-vous d’au moins 25\u00A0% des parts de l’entreprise\u00A0?',
      present:
        'Disposez-vous d’au moins 25\u00A0% des parts de l’entreprise\u00A0?',
    },
    no: 'Non',
    title: 'Votre rôle dans l’entreprise',
    yes: 'Oui',
  },
} as const);
